// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer-module--Footer--2UJjc","RSSIcon":"Footer-module--RSSIcon--2PHxr"};